import { useState, useRef } from 'react';
import api from '../../api';
import stili from './stili';
import ConflittoVersione, { eConflitto } from '../ConflittoVersione';
import AvvisoDatiComuni from './AvvisoDatiComuni';
import { TIPI_SOGGETTO } from '../../pages/anagrafiche/comuni';   // un solo elenco dei tipi di soggetto

// Nuovo cliente dello studio o modifica, con i codici azienda parcellazione di ciascun fatturante

export default function FormClienteStudio({ cliente, ragioneIniziale = '', fatturanti, onChiudi, onSalvato }) {
  const daCliente = c => ({
    ragione_sociale: c?.ragione_sociale || ragioneIniziale,
    codice_fiscale: c?.codice_fiscale || '',
    note: c?.note || '',
    fatturante_default_id: c?.fatturante_default_id || '',
    tipo_soggetto: c?.tipo_soggetto || '',
    attivo: c ? c.attivo : true,
    version: c?.version,
    codici_gis: Object.fromEntries(fatturanti.filter(f => f.attivo || c?.codici_gis?.[f.id]).map(f => [f.id, c?.codici_gis?.[f.id] || ''])),
  });
  const [form, setForm] = useState(daCliente(cliente));
  const collegata = Boolean(cliente?.anagrafica_id);   // nome, codice fiscale e tipo in sola lettura: si modificano in Anagrafiche
  const [errore, setErrore] = useState('');
  const [salvataggio, setSalvataggio] = useState(false);
  const occupato = useRef(false);   // doppio clic: lo stato React si aggiorna solo al ridisegno
  const [conflitto, setConflitto] = useState(null);

  const salva = async (version) => {
    setErrore('');
    if (occupato.current) return;
    occupato.current = true;
    setSalvataggio(true);
    try {
      const res = cliente
        ? await api.put(`/competenze/clienti/${cliente.id}`, { ...form, version })
        : await api.post('/competenze/clienti', form);
      setConflitto(null);
      onSalvato(res.data);
    } catch (err) {
      if (eConflitto(err)) setConflitto(err.response.data);
      else if (err.response?.data?.codice === 'DATI_COMUNI_IN_ANAGRAFICHE') setErrore(`${err.response.data.errore} Chiudi e riapri il modulo per vedere i dati aggiornati.`);
      else setErrore(err.response?.data?.errore || 'Errore nel salvataggio');
    } finally {
      occupato.current = false; setSalvataggio(false);
    }
  };

  return (
    <div style={stili.overlay}>
      <div style={stili.modal}>
        <h3 style={{ marginTop: 0 }}>{cliente ? `Modifica ${cliente.ragione_sociale}` : 'Nuova azienda'}</h3>
        <form onSubmit={e => { e.preventDefault(); salva(form.version); }}>
          {errore && <div style={stili.errore}>{errore}</div>}
          {collegata && <AvvisoDatiComuni anagraficaId={cliente.anagrafica_id} onNavigare={onChiudi} />}
          <div style={stili.campo}>
            <label style={stili.label}>Ragione sociale</label>
            <input autoFocus={!collegata} disabled={collegata} value={form.ragione_sociale} onChange={e => setForm(f => ({ ...f, ragione_sociale: e.target.value }))} required style={stili.input} />
          </div>
          <div style={stili.campo}>
            <label style={stili.label}>Codice fiscale / P.IVA (facoltativo)</label>
            <input disabled={collegata} value={form.codice_fiscale} maxLength={16} onChange={e => setForm(f => ({ ...f, codice_fiscale: e.target.value }))} style={stili.input} />
          </div>
          <div style={stili.row}>
            <div style={stili.campo}>
              <label style={stili.label}>Tipo soggetto (facoltativo)</label>
              <select disabled={collegata} value={form.tipo_soggetto} onChange={e => setForm(f => ({ ...f, tipo_soggetto: e.target.value }))} style={stili.input}>
                <option value="">—</option>
                {Object.entries(TIPI_SOGGETTO).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
              </select>
            </div>
            <div style={stili.campo}>
              <label style={stili.label}>Fatturante predefinito (facoltativo)</label>
              <select value={form.fatturante_default_id} onChange={e => setForm(f => ({ ...f, fatturante_default_id: e.target.value }))} style={stili.input}>
                <option value="">Nessuno</option>
                {fatturanti.filter(f => f.attivo || f.id === cliente?.fatturante_default_id).map(f => <option key={f.id} value={f.id}>{f.nome}{f.attivo ? '' : ' (non attivo)'}</option>)}
              </select>
              <small style={{ color: '#777' }}>Precompila il fatturante delle nuove competenze; resta modificabile su ogni riga.</small>
            </div>
          </div>
          <label style={stili.label}>Codice azienda parcellazione, per ciascun fatturante</label>
          <div style={stili.row}>
            {fatturanti.filter(f => f.attivo || cliente?.codici_gis?.[f.id]).map(f => (
              <div key={f.id} style={{ flex: '1 1 120px' }}>
                <small style={{ color: '#777' }}>{f.nome}</small>
                <input
                  value={form.codici_gis[f.id]}
                  onChange={e => setForm(x => ({ ...x, codici_gis: { ...x.codici_gis, [f.id]: e.target.value } }))}
                  style={stili.input}
                  aria-label={`Codice azienda parcellazione ${f.nome}`}
                />
              </div>
            ))}
          </div>
          <div style={{ ...stili.campo, marginTop: '0.9rem' }}>
            <label style={stili.label}>Note</label>
            <input value={form.note} onChange={e => setForm(f => ({ ...f, note: e.target.value }))} style={stili.input} />
          </div>
          {cliente && (
            <label style={{ fontSize: '0.88rem', display: 'flex', gap: '0.4rem', alignItems: 'center' }}>
              <input type="checkbox" checked={form.attivo} onChange={e => setForm(f => ({ ...f, attivo: e.target.checked }))} />
              Cliente seguito (se tolto, esce dai suggerimenti ma resta nello storico)
            </label>
          )}
          <div style={stili.azioni}>
            <button type="button" onClick={onChiudi} style={stili.btnSecondary}>Annulla</button>
            <button type="submit" disabled={salvataggio} style={stili.btn}>{salvataggio ? 'Salvataggio…' : 'Salva'}</button>
          </div>
        </form>
      </div>
      {conflitto && (
        <ConflittoVersione
          conflitto={conflitto}
          inCorso={salvataggio}
          onRicarica={async () => {
            const r = await api.get('/competenze/clienti', { params: { tutti: 1 } });
            setForm(daCliente(r.data.find(c => c.id === cliente.id) || conflitto.attuale));
            setConflitto(null);
          }}
          onSovrascrivi={() => salva(conflitto.attuale.version)}
        />
      )}
    </div>
  );
}
